module.exports = __webpack_public_path__ + "static/media/7.ba743d7b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/cats/7.jpg
// module id = 212
// module chunks = 0